












import Vue from 'vue';
import SideBar from '@/parts/about/SideBarCorporate.vue';
import ReturnTop from "@/parts/util/ReturnTop.vue";

export default Vue.extend({
  name: 'Guide',
  components: {
    SideBar,
    ReturnTop,
  },
})
